import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";
import { AppProvider } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';

import './App.css';
import '@shopify/polaris/dist/styles.css';

import Home from './components/Home';
import Install from './components/Install';
import AuthRoute from './components/AuthRoute';
import NewProductGroup from './components/ProductGroup/New';
import EditProductGroup from './components/ProductGroup/Edit';

function App(props: any) {
    console.log('App Component',props)
  return (
    <AppProvider i18n={enTranslations}>
        <Router>
            <Switch>
                <AuthRoute exact path="/" component={Home} />
                <AuthRoute path="/product/:handle" component={EditProductGroup} />
                <AuthRoute exact path="/product-group/new" component={NewProductGroup} />
                <Route path="/install">
                    <Install />
                </Route>
            </Switch>
        </Router>
    </AppProvider>
  );
}

export default App;
